import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { Redirect } from "react-router-dom";
import axios from "axios";
import { DEBUG } from "../App";
import { BASE_URL } from "../state/services/common";
import { Container } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { setAuth } from "../state/slices/auth";
import { isAuthenticated } from "../util";

function Callback(props) {
  const history = useHistory();

  const token = useSelector((state) => state.auth.token);
  const expiresAt = useSelector((state) => state.auth.expiresAt);
  const dispatch = useDispatch();

  const query = new URLSearchParams(props.location.search);
  const tokenInURL = query.get("token");

  useEffect(() => {
    if (!tokenInURL) return;
    if (isAuthenticated(token, expiresAt)) history.push("/dashboard");

    const getData = async () => {
      try {
        const result = await axios.post(
          `${BASE_URL}/jhu/login/exchange`,
          {},
          {
            headers: {
              Authorization: `bearer ${tokenInURL}`,
            },
          }
        );

        dispatch(setAuth(result.data));
        history.push("/dashboard");
      } catch (err) {
        DEBUG && console.log(err.response || err);
        history.push("/");
      }
    };

    getData();
  }, [tokenInURL, dispatch, isAuthenticated, history]);

  if (tokenInURL) {
    return (
      <div className="homepage">
        <Container className="content text-center">
          <h1>Loading...</h1>
        </Container>
      </div>
    );
  } else {
    return <Redirect to="/" />;
  }
}

export default Callback;
